import { Injectable } from '@angular/core';
import { RailingMaterialService } from './railing/services/railing-material.service';
import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';
import { RailingColorsService } from './railing/services/railing-colors.service';
import { RailingColorMap } from '../custom/railingColorMap';
import { StageService } from './stage.service';
import { ProductsService } from './products.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { HandrailDisplayService } from './handrail-display.service';
import { SetMaterialsService } from './set-materials.service';
import { ConstantsService } from './constants.service';
import { map } from 'rxjs/operators/map';
import { ProductTypes } from '../models/2d3d/product-types';
import { InfillTypes } from './railing/infills/model/infill-types';
import {
  LOCAL_DOCKRAIL_COLOR_GROUP_ID,
  mergeLocalDockRailColorGroup
} from '../models/2d3d/dockrail-local.config';
import {Subject} from "rxjs/Subject";

declare var THREE: any;

@Injectable()
export class EditRailingColorService {
  colors: any = [];
  colorGroups = [];
  currentTopRail;
  colorsToMenuItem = {};
  handrailColor = false;
  currentUniformColor: object = {};
  uniformRailingColor = {
    selected: [],
    colors: [],
    toggleUniformColor: true,
    visible: true
  };
  railingColorsTest: { [key: string]: RailingColorMap } = {};
  railingColorsToHTML = [];
  private _currentParams: any = {};
  railingColorsToHTMLUpdated = new Subject<any>();
  uniformRailingColorUpdated = new Subject<any>();

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    public stage: StageService,
    public colorsService: RailingColorsService,
    public productsSrvc: ProductsService,
    public railingGeneration: RailingGenerationService,
    private handrailDisplayService: HandrailDisplayService,
    private setMaterialsService: SetMaterialsService,
    private constantsService: ConstantsService
  ) {}

  initFunctions() {
    this.getColorGroups();

    this.railingGeneration.build.subscribe(value => {
      this._currentParams = this.dataForMenu.getCurrentParams();

      this.setVisibleContent();
      this._setUniformColor();
    });
  }

  getColorGroups(): void {
    this.colorsService.getColorGroups().subscribe(colorGroups => {
      this.colorGroups = colorGroups;
      // console.log('this.colorGroups', this.colorGroups);
      this.getColors();
    });
  }

  getColors(): void {
    this.colorsService.getColors().subscribe(colors => {
      this.colors = colors;
      // virtual DockRail group (White/Black/Silver, spec p.20) — assembled
      // from the loaded colors until the real group exists server-side
      this.colorGroups = mergeLocalDockRailColorGroup(this.colorGroups, this.colors);
      // console.log('colors', colors);
      // this.setRailingType();
      // this.setTopRail();
    });
  }

  setVisibleContent() {
    if (!this.railingColorsTest[this._currentParams.railingType]) {
      this.railingColorsTest[this._currentParams.railingType] = new RailingColorMap(
        this._currentParams.railingType,
        this.constantsService.defaultColors[this._currentParams.railingType]
      );
    }

    this._currentParams.railingType === 'DesignRail' && this.situationalRailingElementsVisibility();

    // http://146.185.164.175:8080/browse/FR-925
    if (this.railingColorsTest[this._currentParams.railingType].railingElements['Top Cap']) {
      this.railingColorsTest[this._currentParams.railingType].railingElements['Top Cap'].visible =
        false;
    }

    this.showRailingColors();
  }

  situationalRailingElementsVisibility() {
    const railingElements = this.railingColorsTest[this._currentParams.railingType].railingElements;
    const currentInfill = this._currentParams.infill;
    const infillTypesArr = [...Object.values(InfillTypes)];

    const laserCutElements = infillTypesArr.filter(i => i.includes('laserCut'));
    // const steelMeshElements = infillTypesArr.filter(i => i.includes('steelMesh'));

    const situationalRailingElementsNames = [...laserCutElements];
    const situationalRailingElements = [];

    situationalRailingElementsNames.forEach((n: string) => {
      situationalRailingElements.push(railingElements[ProductTypes[n]]);
    });

    situationalRailingElements.forEach(t => {
      if (ProductTypes[currentInfill] === t.type) {
        t.visible = true;
      } else {
        t.visible = false;
      }
    });
  }

  private _setUniformColor() {
    this.uniformRailingColor.colors.length = 0;
    let colorGroup: any;

    switch (this._currentParams.railingType) {
      // "15 DesignRail Colors" (Modern spec p.2 rule 7) is Color Group 1 —
      // 'All DesignRail Aluminum Components', the same 15 aluminum colors
      // DesignRail itself offers, and the group the Modern products inherit
      // from their donors
      case 'DesignRail':
      case 'Modern': {
        colorGroup = this.colorGroups[0];
        break;
      }
      case 'Wood': {
        colorGroup = this.colorGroups[2];
        break;
      }
      case 'Composite': {
        colorGroup = this.colorGroups[3];
        break;
      }
      case 'Steel flat bar': {
        colorGroup = this.colorGroups[1];
        break;
      }
      case 'Steel round tubular': {
        colorGroup = this.colorGroups[1];
        break;
      }
      case 'DockRail': {
        // White/Black/Silver (spec p.20): the virtual local group, or a real
        // server-side DockRail group once one exists under the same id
        colorGroup = this.getColorGroupById(LOCAL_DOCKRAIL_COLOR_GROUP_ID) || this.colorGroups[1];
        break;
      }
    }

    this.colors
      .filter(c => colorGroup.colors.indexOf(c.id) !== -1)
      .forEach(c => {
        this.uniformRailingColor.colors.push(c);});
    this.uniformRailingColorUpdated.next();
  }

  startMainFunctions() {
    this.colorsService.addProductType.subscribe(obj => {
      if (this.railingColorsTest[this._currentParams.railingType].railingElements[obj.colorType]) {
        this.railingColorsTest[this._currentParams.railingType].railingElements[
          obj.colorType
          ].addProductType(obj.productType);
        this.colorsService.updateColorMap(this.railingColorsTest);
      }
    });

    this.handrailDisplayService.handrailSubj.subscribe(condition => {
      if (!this.railingColorsTest[this._currentParams.railingType]) {
        this.railingColorsTest[this._currentParams.railingType] = new RailingColorMap(
          this._currentParams.railingType,
          this.constantsService.defaultColors[this._currentParams.railingType]
        );
      }
      if (this.railingColorsTest[this._currentParams.railingType]) {
        if (
          this.railingColorsTest[this._currentParams.railingType].railingElements['Stair Handrail']
        ) {
          this.railingColorsTest[this._currentParams.railingType].railingElements[
            'Stair Handrail'
            ].visible = condition;
        }
      }
    });

    this.dataForMenu.topRail.subscribe(value => {
      const railingType = this.dataForMenu.currentChoises.railingType;
      if (railingType === 'Wood' && value === '150s') {
        const colors = this.getItemColors('Top Rail');
        this.railingColorsTest[railingType].railingElements['Top Rail'].setColors(colors);
        this.railingColorsTest[railingType].railingElements['Top Rail'].colors.forEach(el => {
          if (el.name === 'Black') {
            this.railingColorsTest[railingType].railingElements['Top Rail'].setSelectedColor(el);
          }
        });
      } else if (railingType === 'DesignRail' && value === 'Low-Profile for Wood') {
        this.railingColorsTest[railingType].railingElements['Top Cap'].visible = true;
        const colors = this.getItemColors('Top Cap');
        this.railingColorsTest[railingType].railingElements['Top Cap'].setColors(colors);
        this.railingColorsTest[railingType].railingElements['Top Cap'].colors.forEach(el => {
          if (el.name === 'Redwood') {
            this.railingColorsTest[railingType].railingElements['Top Cap'].setSelectedColor(el);
          }
        });
      } else if (this.railingColorsTest[railingType]) {
        const colors = this.getItemColors('Top Rail');
        const selectedColor =
          this.railingColorsTest[railingType].railingElements['Top Rail'].selected;
        if (!colors.some(el => el.name === selectedColor.name)) {
          this.railingColorsTest[railingType].railingElements['Top Rail'].setColors(colors);
          this.railingColorsTest[railingType].railingElements['Top Rail'].setDefaultColor(colors);
        }
        if (this.railingColorsTest[railingType].railingElements['Top Cap']) {
          this.railingColorsTest[railingType].railingElements['Top Cap'].visible = false;
        }
      }
    });
    this.dataForMenu.startNewProj.subscribe(() => this.deleteColors());
    this.dataForMenu.verticalPicketUpdated.subscribe(() => {
      // allow to set default color for picket
      if (this.railingColorsTest[this._currentParams.railingType].railingElements['Picket'])
        this.railingColorsTest[this._currentParams.railingType].railingElements['Picket'].selected =
          false;
      this.showRailingColors();
    });

    // http://146.185.164.175:8080/browse/FR-978
    this.dataForMenu.projectColorsBSubj
      .pipe(
        map(railingColors => {
          if (railingColors && railingColors.length) {
            let uniform = true;
            railingColors.forEach(rc => {
              if (rc.selected.name !== railingColors[0].selected.name) {
                uniform = false;
              }
            });
            if (uniform) {
              this.selectUniformColor({...railingColors[0].selected});
              this.uniformRailingColor.toggleUniformColor = true;
            } else {
              railingColors.forEach((railingColor: any) => {
                railingColor = {...railingColor};
                this.selectTypeColor(railingColor, railingColor.selected);
              });
              this.uniformRailingColor.toggleUniformColor = false;
            }
          }
        })
      )
      .subscribe();
  }

  showRailingColors() {
    // console.log('this.railingColorsTest', this.railingColorsTest);
    this.railingColorsToHTML = [];
    const railingElements = this.railingColorsTest[this._currentParams.railingType].railingElements;

    // http://146.185.164.175:8080/browse/FR-934
    if (this.railingColorsTest[this._currentParams.railingType].railingElements['Picket']) {
      const visible = this.dataForMenu.currentChoises.railingType === 'Wood' ? false : true;
      this.railingColorsTest[this._currentParams.railingType].railingElements['Picket'].visible =
        visible;
    }

    for (const color in railingElements) {
      const colors = this.getItemColors(color);
      railingElements[color].setColors(colors);

      if (!railingElements[color].selected && this._currentParams.railingType !== 'Wood') {
        railingElements[color].setDefaultColor(colors);
      } else if (!railingElements[color].selected && this._currentParams.railingType === 'Wood') {
        railingElements[color].setDefaultColor(colors);
      }

      if (railingElements[color].visible) {
        this.railingColorsToHTML.push(railingElements[color]);
      }

      if (this.railingColorsToHTML.length) {
        this.railingColorsToHTML.sort((a, b) => {
          // http://146.185.164.175:8080/browse/FR-999
          const ordered = ['Top Rail', 'Post', 'Bottom Rail'];
          const aIdx = ordered.findIndex(o => o === a.type);
          const bIdx = ordered.findIndex(o => o === b.type);
          if (aIdx === -1 && bIdx === -1) return 0;
          if (aIdx === -1) return 1;
          if (bIdx === -1) return -1;
          if (aIdx > bIdx) {
            return 1;
          }
          if (aIdx < bIdx) {
            return -1;
          }
          return 0;
        });
      }
    }
    this.railingColorsToHTMLUpdated.next();

    this.uniformRailingColor.selected = this.railingColorsTest[this._currentParams.railingType]
      .selectedUniformColor
      ? this.railingColorsTest[this._currentParams.railingType].selectedUniformColor
      : railingElements['Post'].selected;

    this.colorsService.updateColorMap(this.railingColorsTest);
    this.dataForMenu.updateColorMap(this.railingColorsTest);
  }

  selectUniformColor(selected) {
    this.uniformRailingColor.selected = selected;

    this.railingColorsTest[this._currentParams.railingType].setSelectedUniformColor(selected);
    const railingElements = this.railingColorsTest[this._currentParams.railingType].railingElements;

    for (const color in railingElements) {
      if (railingElements[color].colors.some(el => el.name === selected.name)) {
        railingElements[color].selected = selected;
        this.generateColorsToRail(railingElements[color]);
      }
    }
    this.setCurrentUniformColor(this._currentParams.railingType, selected);
  }

  setCurrentUniformColor(railingType, colors) {
    this.currentUniformColor[railingType] = colors;
  }

  getItemColors(item) {
    let colors = [];
    switch (item) {
      case 'Post': {
        const colorItems = this.productsSrvc.getCurrentIntermidiatePost().colors;
        colorItems.forEach(ci => {
          const colorGroup = this.getColorGroupById(ci);
          colorGroup.colors.forEach(el1 => {
            this.colors.forEach(el2 => {
              if (el1 === el2.id) {
                colors.push(el2);
              }
            });
          });
        });
        break;
      }
      case 'Bottom Rail': {
        const colorItems = this.productsSrvc.getCurrentBaserail().colors;
        colorItems.forEach(ci => {
          const colorGroup = this.getColorGroupById(ci);
          colorGroup.colors.forEach(el1 => {
            this.colors.forEach(el2 => {
              if (el1 === el2.id) {
                colors.push(el2);
              }
            });
          });
        });
        break;
      }
      case 'Top Rail': {
        const colorItems = this.productsSrvc.getCurrentHandrail().colors;
        colorItems.forEach(ci => {
          const colorGroup = this.getColorGroupById(ci);
          colorGroup.colors.forEach(el1 => {
            this.colors.forEach(el2 => {
              if (el1 === el2.id) {
                colors.push(el2);
              }
            });
          });
        });
        break;
      }
      case 'Picket': {
        let colorItems =
          this._currentParams.infill === 'horizontalCableBaserail' ||
          this._currentParams.infill === 'horizontalCable'
            ? this.productsSrvc.getCurrentHorizontalCableVerticalPicket().colors
            : this.productsSrvc.getCurrentVerticalPicket().colors;

        // TODO: force adding one more color group "Stainless Steel". Its missing in current data from base
        colorItems = [...colorItems, '5e67a61d74ba3c5e0a45769e'];

        colorItems.forEach(ci => {
          const colorGroup = this.getColorGroupById(ci);
          colorGroup.colors.forEach(el1 => {
            this.colors.forEach(el2 => {
              if (el1 === el2.id) {
                colors.push(el2);
              }
            });
          });
        });
        break;
      }
      case 'Stair Handrail': {
        this.colorGroups[0].colors.forEach(el1 => {
          this.colors.forEach(el2 => {
            if (el1 === el2.id) {
              colors.push(el2);
            }
          });
        });
        break;
      }
      case 'Top Cap': {
        this.colorGroups[2].colors.forEach(el1 => {
          this.colors.forEach(el2 => {
            if (el1 === el2.id) {
              colors.push(el2);
            }
          });
        });
        break;
      }
      default: {
        // Any laser-cut design ('Laser Cut <Name>' product types, incl. Kerri Kelly)
        // http://146.185.164.175:8080/browse/FR-1007
        if (typeof item === 'string' && item.indexOf('Laser Cut') === 0) {
          const colorItems = this.colorGroups[0].colors;
          colorItems.forEach(ci => {
            this.colors.forEach(color => {
              if (color.id === ci) {
                colors.push(color);
              }
            });
          });
        }
        break;
      }
      case ProductTypes.steelMeshAllure:
      case ProductTypes.steelMeshDazzle:
      case ProductTypes.steelMeshMetropolitan:
      case ProductTypes.steelMeshHorizon: {
        const colorItems = this.productsSrvc.getCurrentHandrail().colors;
        colorItems.forEach(ci => {
          const colorGroup = this.getColorGroupById(ci);
          colorGroup.colors.forEach(el1 => {
            this.colors.forEach(el2 => {
              if (el1 === el2.id) {
                colors.push(el2);
              }
            });
          });
        });
        break;
      }
    }

    return colors;
  }

  confirmTheChangeForEditVerticalPicket(selected) {
    if (
      !selected.colorName.includes('Stainless') && this.dataForMenu.getRailOptions('infillStSteelPickets')
    ) {
      const text = '“Please Note: Changing your picket color will change your Infill options selection from Stainless Steel to painted aluminum pickets”';
      if (confirm(text) === true) {
        return false;
      } else {
        return true;
      }
    }
  }

  confirmTheChange(type, selected, callEditInfill) {
    if (
      !callEditInfill &&
      type.type === 'Picket' &&
      selected.name !== 'Stainless Steel' &&
      this.dataForMenu.getRailOptions('infillStSteelPickets')
    ) {
      const text = '“Please Note: Changing your picket color will change your Infill options selection from Stainless Steel to painted aluminum pickets”';
      if (confirm(text) === true) {
        return false;
      } else {
        return true;
      }
    }
  }

  selectTypeColor(type, selected, callEditInfill = false) {
    if (this.confirmTheChange(type, selected, callEditInfill)) {
        return;
    }
    type.selected = selected;

    if (this.railingColorsTest[this._currentParams.railingType].railingElements[type.type]) {
      this.railingColorsTest[this._currentParams.railingType].railingElements[
        type.type
        ].setSelectedColor(selected);

      this.generateColorsToRail(
        this.railingColorsTest[this._currentParams.railingType].railingElements[type.type]
      );
    }
    this.colorsService.updateColorMap(this.railingColorsTest);
    if (type.type === 'Picket') {
      // this.dataForMenu.setVerticalPicket(this.dataForMenu.currentChoises.verticalPicketShapeType, selected.name);
      if (selected.name !== 'Stainless Steel') {
        this.dataForMenu.setRailOptions('infillStSteelPickets', false);
        this.dataForMenu.infillStSteelPicketsUpdated.next(false);
      } else {
        this.dataForMenu.setRailOptions('infillStSteelPickets', true);
        this.dataForMenu.infillStSteelPicketsUpdated.next(true);
      }
    }
  }

  generateColorsToRail(menuItem) {
    const modelsOnStage = this.stage.getChildren();
    for (let i = 0; i < modelsOnStage.length; i++) {
      for (let j = 0; j < modelsOnStage[i].children.length; j++) {
        const entity = modelsOnStage[i].userData.entity;
        if (entity) {
          if (
            this.railingColorsTest[this._currentParams.railingType].railingElements[
              menuItem.type
              ].productTypes.some(el => el === entity.productType)
          ) {
            this.colorsService.setExistingColor(modelsOnStage[i], menuItem.type);
          }

          this.colorsService.syncObjColors(modelsOnStage[i]);
        }
      }
    }
  }

  getColorGroupById(id: string) {
    return this.colorGroups.find(g => g.id === id);
  }

  deleteColors() {
    for (const color in this.railingColorsTest) {
      delete this.railingColorsTest[color];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/edit-railing-color.service.ts